import React, {useState} from 'react'
import {useDispatch} from 'react-redux'
import {useForm} from 'react-hook-form'

import {useNavigate} from 'react-router-dom'
// import {toast} from 'react-toastify'
import {Button} from 'helpers/ui-components/Button'
import Spinner from 'layout/common/Spinner'
import {useTranslation} from 'react-i18next'
import {Select2DropdownField} from 'helpers/ui-components/form/Select2DropdownField'
import {KTSVG} from 'helpers/ui-components/KTSVG'
import {KTText} from 'helpers/ui-components/KTText'
import {IFormData} from 'models/Common'
import {setOTPData} from 'redux/slice/authSlice'
import {generateOTP} from 'utils/api/auth/registerService'
// type Props = {}

const VerifyMobileNoPage = () => {
 const {t} = useTranslation()

 const dispatch = useDispatch()
 const navigate = useNavigate()
 const [loader, setLoader] = useState(false)
 const loginForm = {
  mobileNumber: '',
  country: 'ind',
 }
 const {
  register,
  control,
  handleSubmit,
  formState: {errors},
 } = useForm({
  mode: 'all',
  reValidateMode: 'onChange',
  defaultValues: {...loginForm},
 })
 const countryList = [
  {
   name: (
    <KTSVG
     path='/media/img/country/india.svg'
     svgClassName='w-[40px]'
    />
   ),
   alternate_name: 'India',
   value: 'ind',
  },
 ]

 async function submitLoginFormData(formData: IFormData) {
  setLoader(true)
  const res = await generateOTP({
   phone_number: formData?.mobileNumber,
   refernce: 'mobile_verification_otp',
  })
  if (res) {
   dispatch(
    setOTPData({
     mobileNo: formData?.mobileNumber,
     userId: res,
    })
   )
   navigate('/verify-ac-otp-page')
  }
  setLoader(false)
 }
 return (
  <>
   {loader && <Spinner />}
   <div className='container bg-white'>
    <div className='bg-white flex justify-center min-h-full sm:pt-3 md:pt-14 sm:px-2'>
     <form
      method='POST'
      action=''
      onSubmit={handleSubmit(submitLoginFormData)}
     >
      <div className='relative sm:w-full md:w-[360px] '>
       <div className='border-b border-b-[#CED8E0] w-full text-left pb-2 pt-4'>
        <span className='text-[#33393D] text-lg font-bold'>
         {t('verifyMobileNo.title')}
        </span>
       </div>
       <div className='relative w-full mt-8'>
        <div
         className={`flex w-full items-stretch rounded-lg bg-white overflow-hidden h-[56px] border ${
          errors?.mobileNumber
           ? '!border-[#CC293F]'
           : 'border-[#E6EBF0]'
         }`}
        >
         <Select2DropdownField
          className='image-selector relative m-0 block text-black text-xs w-[95px] sm:w-[110px] border-0 font-semibold'
          wrapperClassName='relative flex-shrink-0 flex items-center bg-[#E6EBF0]'
          inputWrapperClassName='!rounded-none'
          required={false}
          isClearable={false}
          isSearchable={false}
          control={control}
          customStyle={{
           borderColor: 'transparent',
           border: '0px',
           borderTopLeftRadius: '0px',
           borderBottomLeftRadius: '0px',
           borderTopRightRadius: '0px',
           borderBottomRightRadius: '0px',
           padding: '0px 8px 0px 0px',
           height: '56px',
           backgroundColor: '#E6EBF0',
          }}
          data={countryList}
          id={`country`}
          name={`country`}
          value={'en'}
          onChange={() => {
           // handleChangeLanguage(e.target.value)
          }}
          OptionValueKey='value'
          OptionLabelKey='name'
          placeholder={t('verifyMobileNo.country')}
         />
         <div className='flex-1 bg-white relative flex items-center'>
          <label
           htmlFor='mobileNumber'
           className='absolute left-4 top-1 text-[#4E83E4] text-xs font-medium'
          >
           {t('verifyMobileNo.mobileNoFieldLabel')}
          </label>
          <input
           type='tel'
           inputMode='numeric'
           pattern='[0-9]*'
           maxLength={10}
           id='mobileNumber'
           placeholder={t('helperText.enterHere')}
           className='w-full h-full bg-transparent text-[#33393D] text-lg font-normal pt-4 pb-2 pl-4 pr-4 focus:outline-none'
           {...register('mobileNumber', {
            validate: {
             regex: (v: string) => {
              if (v !== '' && !v?.match('^[6-9][0-9]{9}$'))
               return `${t('helperText.plsEnterValid')} ${t(
                'verifyMobileNo.mobileNo'
               )}`
             },
             required: (v) => {
              if (v === '')
               return `${t('helperText.plsEnter')} ${t(
                'verifyMobileNo.mobileNo'
               )}`
             },
            },
           })}
          />
         </div>
        </div>
        {errors?.mobileNumber ? (
         <p className='error-msg error-cls mt-2'>
          {errors?.mobileNumber?.message as string}
         </p>
        ) : (
         <KTText className='text-xs text-[#5F6B7B] mt-2'>
          {t('verifyMobileNo.mobileNoFieldHelperText')}
         </KTText>
        )}
       </div>
       <div className='md:flex items-center justify-center w-full mt-8'>
        <Button
         disabled={errors && Object.keys(errors).length > 0}
         type='submit'
         color='blue'
         className='text-center w-full py-[9px] px-[24px] bg-[#4E83E4] 
                  !rounded-lg !text-base text-white font-semibold'
        >
         {t('verifyMobileNo.getOTP')}
        </Button>
       </div>
      </div>
     </form>
    </div>
   </div>
  </>
 )
}

export default function VerifyMobileNoPageWrapper() {
 // for using different languages and changing the text in to other languages
 // const intl = useIntl()
 return (
  <>
   <VerifyMobileNoPage />
  </>
 )
}
